<template>
    <div class="row " v-if=" isValid('CanAddSignUpUser') || isValid('CanEditSignUpUser') " v-bind:style="$i18n.locale == 'ar' ? languageChange('en') : languageChange('ar')">
        <div class="col-md-8 ml-auto mr-auto" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
            <div class="card">
                <div class="card-body" v-if="loginDetails.id=='00000000-0000-0000-0000-000000000000'">
                    <h5 class="card-title DayHeading" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'text-right'">{{ $t('AddSignUp.SignUpDetails') }}</h5>
                    <div class="row">
                        <div class="col-sm-6">
                            <label>{{ $t('AddSignUp.Employee') }}:<span class="LabelColour"> *</span></label>
                            <employeeDropdown v-on:input="getEmployeeDetails($event)" v-bind:isSignup='true'></employeeDropdown>
                        </div>
                        <div class="col-sm-6">
                        </div>
                        <div class="col-sm-6 ">
                            <label>{{ $t('AddSignUp.EmployeeIDNumber') }}</label>
                            <div>
                                <input class="form-control " disabled v-model="idNumber" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" />
                            </div>
                        </div>
                        <div class="col-sm-6 ">
                            <label>{{ $t('AddSignUp.EmployeeRegistrationDate') }}</label>
                            <div>
                                <input class="form-control" disabled v-model="registrationDate" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" />
                            </div>
                        </div>
                        <div class="col-sm-6 " hidden>
                            <label>{{ $t('SignUp.EmployeeArabicName') }}</label>
                            <div>
                                <input class="form-control" disabled v-model="arabicName" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" />
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label>{{ $t('AddSignUp.EmployeeEmail') }} :<span class="LabelColour"> *</span></label>
                            <div v-bind:class="{'has-danger' : $v.loginDetails.email.$error}">
                                <input class="form-control" disabled v-model="$v.loginDetails.email.$model" @blur="EmailDuplicate(loginDetails.email)" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" />
                                <span v-if="$v.loginDetails.email.$error" class="error text-danger">
                                    <span v-if="!$v.loginDetails.email.required"> {{ $t('AddSignUp.RegisterUser_Error_Required_EmailID') }} </span>
                                    <span v-if="!$v.loginDetails.email.email"> {{ $t('AddSignUp.RegisterUser_Error_Format_EmailID') }} </span>
                                </span>
                                <span class="text-right text-danger" v-if="emailExist">{{ $t('AddSignUp.EmailExist') }}</span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label>{{ $t('AddSignUp.UserId') }} :<span class="LabelColour"> *</span></label>
                            <div v-bind:class="{'has-danger' : $v.loginDetails.userName.$error}">
                                <input class="form-control" v-model="$v.loginDetails.userName.$model" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" />
                                <span v-if="$v.loginDetails.userName.$error" class="error text-danger">
                                    <span v-if="!$v.loginDetails.userName.required"> {{ $t('AddSignUp.RegisterUser_Error_Required_DisplayName') }}</span>
                                </span>
                            </div>
                        </div>
                        <!--<div class="col-sm-6 ">
                            <label>{{ $t('SignUp.Terminal') }}</label>
                            <div>
                                <terminal-dropdown v-model="loginDetails.terminalId" />
                            </div>
                        </div>-->
                        <div class="col-sm-6">
                            <label> {{ $t('AddSignUp.Password') }} :<span class="LabelColour"> *</span></label>
                            <div v-bind:class="{'has-danger' : $v.loginDetails.password.$error}">
                                <div class="input-group" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">

                                    <input id="password" v-model="$v.loginDetails.password.$model" name="password" :type="password1" v-bind:placeholder="$t('AddSignUp.Password')" class="form-control" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? ' border-top-right-radius: 0; border-bottom-right-radius: 0;' : ' border-top-right-radius: 0; border-bottom-right-radius: 0;border-right: 2px !important' " v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">
                                    <div class="input-group-prepend" v-on:mousedown="showPassword1" @mouseleave="hidepassword1">
                                        <span class="input-group-text" style="padding:10px;border-top-right-radius: 5px;border-bottom-right-radius: 5px;border-right:1px solid #4d49716b;cursor:pointer;}">
                                            <i v-bind:class="eyeValue1?  'fa fa-eye-slash' : 'fas fa-eye'"></i>
                                        </span>
                                    </div>

                                    <!--<button style="  border-left:!important none; border:1px solid rgb(190 190 191); background-color:white"  v-on:click="showPassword"><i class="fas fa-eye"></i></button>-->
                                </div>


                                <span v-if="$v.loginDetails.password.$error" class="error text-danger">
                                    <span v-if="!$v.loginDetails.password.required">{{ $t('AddSignUp.RegisterUser_Error_Required_Password') }}</span>
                                    <span v-if="!$v.loginDetails.password.strongPassword">{{ $t('AddSignUp.RegisterUser_Error_Format_Password') }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <label>{{ $t('AddSignUp.ConfirmPassword') }}:<span class="LabelColour"> *</span></label>

                            <div v-bind:class="{'has-danger' : $v.loginDetails.confirmPassword.$error}">
                                <div class="input-group" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'">

                                    <input id="password" v-model="$v.loginDetails.confirmPassword.$model" name="password" :type="password" v-bind:placeholder="$t('AddSignUp.Password')" class="form-control" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" v-bind:style="($i18n.locale == 'en' ||isLeftToRight()) ? ' border-top-right-radius: 0; border-bottom-right-radius: 0;' : ' border-top-right-radius: 0; border-bottom-right-radius: 0;border-right: 2px !important' ">
                                    <div class="input-group-prepend" v-on:mousedown="showPassword" @mouseleave="hidepassword">
                                        <span class="input-group-text" style="padding:10px;border-top-right-radius: 5px;border-bottom-right-radius: 5px;border-right:1px solid #4d49716b;cursor:pointer;}">
                                            <i v-bind:class="eyeValue?  'fa fa-eye-slash' : 'fas fa-eye'"></i>
                                        </span>
                                    </div>

                                    <!--<button style="  border-left:!important none; border:1px solid rgb(190 190 191); background-color:white"  v-on:click="showPassword"><i class="fas fa-eye"></i></button>-->
                                </div>                                <span v-if="$v.loginDetails.confirmPassword.$error" class="error text-danger">
                                    <span v-if="!$v.loginDetails.confirmPassword.required">{{ $t('AddSignUp.RegisterUser_Error_Required_ConfirmPassword') }}</span>
                                    <span v-if="!$v.loginDetails.confirmPassword.sameAsPassword">{{ $t('AddSignUp.RegisterUser_Error_SameAs_ConfirmPassword') }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <h5 class="card-title  ml-4">{{ $t('AddSignUp.SalesUserPermissions') }}</h5>
                    <div class="row">

                        <div class="col-sm-6" hidden>
                            <label>{{ $t('AddSignUp.UserEmail') }}:<span class="LabelColour"> *</span></label>
                            <div v-bind:class="{'has-danger' : $v.loginDetails.email.$error}">
                                <input disabled class="form-control " v-model="$v.loginDetails.email.$model" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" />
                                <span v-if="$v.loginDetails.email.$error" class="error text-danger">
                                    <span v-if="!$v.loginDetails.email.required">{{ $t('AddSignUp.RegisterUser_Error_Required_EmailID') }}</span>
                                    <span v-if="!$v.loginDetails.email.email"> {{ $t('AddSignUp.RegisterUser_Error_Format_EmailID') }}</span>
                                </span>
                            </div>
                        </div>

                        <div class="col-sm-6 mb-2">
                            <label>{{ $t('AddSignUp.Roles') }}:<span class="LabelColour"> *</span></label>
                            <div>
                                <roledropdown ref="roleComponent" @input="SaleManRol(loginDetails.roleId)" v-model="loginDetails.roleId" :key="rander" v-bind:values="loginDetails.roleId"></roledropdown>
                            </div>
                        </div>
                        <div class="col-sm-6 mb-2">
                        </div>
                        <div class="col-sm-6 mb-2" v-if="dayStart!='false'">
                            <label>{{ $t('AddSignUp.Terminal') }}</label>
                            <div>
                                <terminal-dropdown :terminalType="terminalType" v-model="loginDetails.terminalId" :isSelect="true" v-bind:key="terminalRander" :values="loginDetails.terminalId" />
                            </div>
                        </div>
                        <div class="col-sm-6 mb-2" v-if="dayStart!='false'">
                            <label>{{ $t('AddSignUp.Invoice') }}</label>
                            <multiselect v-if="($i18n.locale == 'en' ||isLeftToRight())" v-model="isTouch" class="mb-2" :options="['Touch Invoice','Invoice Barcode']" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" :show-labels="false" :placeholder="$t('AddSignUp.SelectOption')">
                            </multiselect>
                            <multiselect v-else v-model="isTouch" class="mb-2" :options="['Touch Invoice', 'Invoice Barcode']" :show-labels="false" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" :placeholder="$t('AddSignUp.SelectOption')">
                            </multiselect>
                        </div>
                    </div>
                    <div class="row" :key="randered">
                        <div class="col-sm-6">
                            <span>
                                <toggle-button v-model="loginDetails.isExpenseAccount" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.AllowDailyExpense') }} </label><br />
                            </span>
                            <span>
                                <toggle-button v-model="loginDetails.changePriceDuringSale" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.AllowedDuringSale') }}</label><br />
                            </span>

                            <span>
                                <toggle-button v-model="loginDetails.giveDicountDuringSale" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.AllowedtoGivDiscount') }}</label><br />
                            </span>

                            <span v-if="dayStart!='false'">
                                <toggle-button v-model="loginDetails.viewCounterDetails" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.AllowedCounterDetails') }}</label><br />
                            </span>

                            <span v-if="dayStart!='false'">
                                <toggle-button v-model="loginDetails.transferCounter" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.AllowedTransferCounter') }} </label><br />
                            </span>

                            <span v-if="dayStart!='false'">
                                <toggle-button v-model="loginDetails.closeCounter" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label>{{ $t('AddSignUp.CloseCounter') }}</label><br />
                            </span>

                            <span v-if="invoiceWoInventory=='true'">
                                <toggle-button v-if="dayStart!='false'" v-model="loginDetails.invoiceWoInventory" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label v-if="dayStart!='false'">{{ $t('AddSignUp.InvoiceWoInventory') }}</label><br />
                            </span>

                            <span v-if="dayStart!='false'">
                                <toggle-button v-model="loginDetails.allowAll" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.AllowAll') }}</label><br />
                            </span>
                            <span v-if="dayStart!='false'">
                                <toggle-button v-model="loginDetails.permissionToStartExpenseDay" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.PermissionToStartExpenseDay') }}</label><br />
                            </span>
                            <span v-if="dayStart!='false'">
                                <toggle-button v-model="loginDetails.isSupervisor" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> Is Supervisor</label><br />
                            </span>
                        </div>
                        <div class="col-sm-6">
                            <span v-if="dayStart!='false'">
                                <toggle-button v-model="loginDetails.holdCounter" color="#3178F6" class="mr-2 ml-2 " style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.AllowedtoHoldCounter') }} </label><br />
                            </span>

                            <span v-if="dayStart!='false'">
                                <toggle-button v-model="loginDetails.closeDay" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label>{{ $t('AddSignUp.AllowedtoCloseDay') }}</label><br />
                            </span>

                            <span v-if="dayStart!='false'">
                                <toggle-button v-model="loginDetails.processSaleReturn" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.AllowedSaleReturn') }}</label><br />
                            </span>

                            <!--<span v-if="dayStart!='false'">
                                <toggle-button v-model="loginDetails.dailyExpenseList" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label>{{ $t('SignUp.AllowedExpenseList') }}</label><br />
                            </span>-->

                            <span v-if="dayStart!='false'">
                                <toggle-button v-model="loginDetails.startDay" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.AllowedtoStartDay') }}</label><br />
                            </span>
                            <span>
                                <toggle-button v-model="loginDetails.isActive" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.IsActive') }}</label><br />
                            </span>
                            <span>
                                <toggle-button v-model="loginDetails.temporaryCashReceiver" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.TemporaryCashReceiver') }}</label><br />
                            </span>
                            <span>
                                <toggle-button v-model="loginDetails.temporaryCashIssuer" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.TemporaryCashIssuer') }}</label><br />
                            </span>
                            <span>
                                <toggle-button v-model="loginDetails.temporaryCashRequester" color="#3178F6" class="mr-2 ml-2" style="z-index:0 !important" />
                                <label> {{ $t('AddSignUp.TemporaryCashRequester') }}</label><br />
                            </span>
                        </div>

                        <div class="col-sm-6" v-if="loginDetails.temporaryCashReceiver">
                            <label>{{ $t('AddSignUp.Days') }} :<span class="LabelColour"> *</span></label>
                            <input class="form-control" type="number" v-model="loginDetails.days" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" />
                        </div>
                        <div class="col-sm-6" v-if="loginDetails.temporaryCashReceiver">
                            <label>{{ $t('AddSignUp.Limit') }} :<span class="LabelColour"> *</span></label>
                            <input class="form-control" type="number" v-model="loginDetails.limit" v-bind:class="($i18n.locale == 'en' ||isLeftToRight()) ? 'text-left' : 'arabicLanguage'" />
                        </div>
                    </div>
                    <div class=" col-md-12 text-right">
                        <button class="btn btn-primary   mr-2" v-on:click="SaveLoginDetails" v-if="loginDetails.id=='00000000-0000-0000-0000-000000000000' && isValid('CanAddSignUpUser')" v-bind:disabled="$v.loginDetails.$invalid || (!isOpenDay && loginDetails.terminalId=='')"><i class="far fa-save"></i> {{ $t('AddSignUp.btnSave') }}</button>
                        <button class="btn btn-primary   mr-2" v-on:click="UpdateLoginDetails(userId)" v-if="loginDetails.id!='00000000-0000-0000-0000-000000000000' && isValid('CanEditSignUpUser')" v-bind:disabled="$v.loginDetails.$invalid && (!isOpenDay && loginDetails.terminalId=='')"><i class="far fa-save"></i> {{ $t('AddSignUp.btnUpdate') }}</button>
                        <button class="btn btn-danger   mr-2" v-on:click="Cancel">{{ $t('AddSignUp.btnClear') }}</button>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div v-else> <acessdenied></acessdenied></div>
</template>
<script>
    import moment from "moment";
    import clickMixin from '@/Mixins/clickMixin'
    import Multiselect from 'vue-multiselect'
    import { required, sameAs, email } from 'vuelidate/lib/validators';
    export default ({
        mixins: [clickMixin],
        components: {
            Multiselect,
        },
        data: function () {
            return {
                invoiveItem: false,
                invoiveBarCode: false,
                invoiveBarCodeItem: false,
                terminalType: '',
                dayStart: '',
                arabic: '',
                english: '',
                isTouch: '',
                invoiceWoInventory: '',
                registrationDate: '',
                arabicName: '',
                emailExist: false,
                gender: '',
                idNumber: '',
                userId: '',
                rander: 0,
                randered: 0,
                language: 'Nothing',
                password: "password",
                password1: "password",
                eyeValue: false,
                eyeValue1: false,
                isOpenDay: '',
                terminalRander: 0,
                options: [],
                loginDetails: {
                    id: '00000000-0000-0000-0000-000000000000',
                    email: '',
                    employeeId: '',
                    userName: '',
                    password: '',
                    confirmPassword: '',
                    isExpenseAccount: false,
                    changePriceDuringSale: false,
                    giveDicountDuringSale: false,
                    viewCounterDetails: false,
                    transferCounter: false,
                    closeCounter: false,
                    holdCounter: false,
                    closeDay: false,
                    processSaleReturn: false,
                    dailyExpenseList: false,
                    shiftStartTime: false,
                    shiftEndTime: false,
                    invoiceWoInventory: false,
                    terminalId: '',
                    isTouchInvoice: false,
                    isActive: true,
                    allowAll: false,
                    permissionToStartExpenseDay: false,
                    isSupervisor: false,
                    temporaryCashReceiver: false,
                    temporaryCashIssuer: false,
                    temporaryCashRequester: false,
                    roleId: '',
                    days: 0,
                    limit: 0,
                    touchScreen: ''
                }
            }
        },
        validations: {
            loginDetails: {
                userName: { required },
                password:
                {
                    required,
                    strongPassword(password) {
                        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&]).{8,}$/.test(password);
                    }
                },
                confirmPassword:
                {
                    required,
                    sameAsPassword: sameAs('password')
                },
                email:
                {
                    required,
                    email
                },
                roleId:
                {
                    required,
                },
                //days: {
                //    required: requiredIf((x) => {
                //        if (x.temporaryCashReceiver)
                //            return true;
                //        return false;
                //    }),
                //},
                //limit: {
                //    required: requiredIf((x) => {
                //        if (x.temporaryCashReceiver)
                //            return true;
                //        return false;
                //    }),
                //},
            }
        },
        methods: {
            showPassword() {
                if (this.password === "password") {
                    this.password = "text";
                    this.eyeValue = true;
                }

            },
            hidepassword() {
                this.password = "password"
                this.eyeValue = false;
            },
            showPassword1() {

                if (this.password1 === "password") {
                    this.password1 = "text";
                    this.eyeValue1 = true;
                }

            },
            hidepassword1() {

                this.password1 = "password"
                this.eyeValue1 = false;
            },
            //userNameRejix: function (value) {
            //
            //    this.userName = value.replace(/[^A-Z0-9]/ig, "").toLowerCase();
            //    console.log(this.userName);
            //},
            SaleManRol: function (Id) {

                this.GetTerminalData();
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.$https.get('/Company/NobleRolesDetail?Id=' + Id, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            if (response.data.name == 'Sales Man' || response.data.nameArabic == '') {
                                root.loginDetails.invoiceWoInventory = true;
                                root.loginDetails.isExpenseAccount = true;
                                root.loginDetails.changePriceDuringSale = true;
                                root.loginDetails.giveDicountDuringSale = true;
                                root.loginDetails.viewCounterDetails = true;
                                root.loginDetails.transferCounter = true;
                                root.loginDetails.closeCounter = true;
                                root.loginDetails.holdCounter = true;
                                root.loginDetails.closeDay = true;
                                root.loginDetails.startDay = true;
                                root.loginDetails.processSaleReturn = true;
                                root.loginDetails.dailyExpenseList = true;
                                root.loginDetails.terminals = true;
                                root.randered++;
                            }
                            else {
                                root.loginDetails.isExpenseAccount = false;
                                root.loginDetails.invoiceWoInventory = false;
                                root.loginDetails.changePriceDuringSale = false;
                                root.loginDetails.giveDicountDuringSale = false;
                                root.loginDetails.viewCounterDetails = false;
                                root.loginDetails.transferCounter = false;
                                root.loginDetails.closeCounter = false;
                                root.loginDetails.holdCounter = false;
                                root.loginDetails.closeDay = false;
                                root.loginDetails.startDay = false;
                                root.loginDetails.processSaleReturn = false;
                                root.loginDetails.dailyExpenseList = false;
                                root.loginDetails.terminals = false;
                                root.loginDetails.isActive = true;
                                root.randered++;
                            }
                        }
                    });


            },
            GetTerminalData: function () {

                var selectedRole = this.$refs.roleComponent.GetNameOfSelected();
                if (selectedRole === 'Salesman') {
                    this.terminalType = 'CashCounter'
                    this.terminalRander++
                }
                else {
                    this.terminalType = 'All'
                    this.terminalRander++
                }
            },

            languageChange: function (lan) {
                if (this.language == lan) {
                    if (this.loginDetails.id == '00000000-0000-0000-0000-000000000000') {

                        var getLocale = this.$i18n.locale;
                        this.language = getLocale;

                        this.$router.go('/AddSignUp');
                    }
                    else {
                        this.$swal({
                            title: 'Error!',
                            text: 'You cannot Change language during update, otherwise your current page data will be lose',
                            type: 'error',
                            confirmButtonClass: "btn btn-danger",
                            icon: 'error',
                            timer: 4000,
                            timerProgressBar: true,
                        });
                    }
                }


            },
            EmailDuplicate: function (x) {
                var root = this;
                var token = '';
                if (root.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                root.emailExist = false;
                this.$https.get('/account/DuplicateEmail?email=' + x, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data == true) {
                            root.emailExist = true;
                        }
                        else {
                            root.emailExist = false;
                        }


                    })
            },

            Cancel: function () {
                this.$router.push({
                    path: '/signUp',

                })
            },
            getTerminalIds: function (value) {
                this.loginDetails.terminals = value;
            },
            getEmployeeDetails: function (event) {
                var selectedemployeeId = event;
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/EmployeeRegistration/EmployeeDetail?Id=' + selectedemployeeId, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(function (response) {
                        if (response.data != null) {
                            root.loginDetails.employeeId = response.data.id;
                            root.registrationDate = response.data.registrationDate;
                            if (root.arabic == 'true' && root.english == 'false') {
                                root.arabicName = response.data.arabicName;
                            }
                            else if (root.arabic == 'false' && root.english == 'true') {
                                root.arabicName = response.data.englishName;
                            }
                            else {
                                root.arabicName = response.data.arabicName;
                            }
                            //root.loginDetails.userName = response.data.englishName;
                            root.loginDetails.email = response.data.email;
                            root.gender = response.data.gender;
                            root.idNumber = response.data.idNumber;
                            root.registrationDate = moment().format("DD MM YYYY");
                            if (root.loginDetails.email != '' && root.loginDetails.email != null) {
                                root.EmailDuplicate(root.loginDetails.email);
                            }
                        }
                    },
                        function (error) {
                            this.loading = false;
                            console.log(error);
                        });
            },
            SaveLoginDetails: function () {
                this.loading = true;
                var root = this;
                var token = '';
                
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                if (this.emailExist) {
                    this.$swal({
                        title: "Error!",
                        text: "Email Already Exist!",
                        type: 'error',
                        icon: 'error',
                        showConfirmButton: false,
                        timer: 1700,
                        timerProgressBar: true,
                    });
                }
                else {

                    if (this.isTouch == 'Touch Invoice') {
                        this.loginDetails.isTouchInvoice = true
                    }
                    else {
                        this.loginDetails.isTouchInvoice = false
                    }
                    this.loginDetails.isActive = !this.loginDetails.isActive;
                    localStorage.setItem('AllowAll', this.loginDetails.allowAll);

                    root.$https
                        .post('/account/SaveUser', this.loginDetails, { headers: { "Authorization": `Bearer ${token}` } })
                        .then(response => {
                            if (response.data != "Already Exists") {
                                this.loading = false
                                this.info = response.data.bpi


                                this.$swal.fire({
                                    icon: 'success',
                                    title: 'Saved Successfully',
                                    showConfirmButton: false,
                                    timer: 1800,
                                    timerProgressBar: true,

                                });
                                this.$router.push('/signUp');
                            }
                            else {
                                this.loading = false
                                this.info = response.data.bpi

                                this.$swal.fire({
                                    icon: 'error',
                                    title: 'UserId Already Exist',
                                    showConfirmButton: false,
                                    timer: 1800,
                                    timerProgressBar: true,

                                });
                            }
                        })
                        .catch(error => {
                            console.log(error)
                            this.$swal.fire(
                                {
                                    icon: 'error',
                                    title: 'Server Error',
                                    text: error,
                                });

                            this.loading = false
                        })
                        .finally(() => this.loading = false)
                }
            },
            UpdateLoginDetails: function (userId) {

                this.userId = userId;
                this.loading = true;
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                
                if (this.isTouch == 'Touch Invoice') {
                    this.loginDetails.isTouchInvoice = true
                }
                else {
                    this.loginDetails.isTouchInvoice = false
                }
                this.loginDetails.isActive = !this.loginDetails.isActive;
                localStorage.setItem('AllowAll', this.loginDetails.allowAll);
                root.$https
                    .post('/account/SaveUser', this.loginDetails, { headers: { "Authorization": `Bearer ${token}` } })
                    .then(response => {
                        if (response.data != null) {
                            root.loading = false

                            root.$swal.fire({
                                icon: 'success',
                                title: 'Saved Successfully',
                                showConfirmButton: false,
                                timer: 1800,
                                timerProgressBar: true,

                            });
                            root.$router.push('/signUp');
                        }
                        
                    })
                    .catch(error => {
                        console.log(error)
                        root.$swal.fire(
                            {
                                icon: 'error',
                                title: 'Server Error',
                                text: error,
                            });

                        root.loading = false
                    })
                    .finally(() => root.loading = false)
            },
            getUserWiseRecords: function () {

                if (this.$route.query.data != undefined) {
                    this.loginDetails.id = this.$route.query.data.id;
                    this.userId = this.$route.query.data.userId;
                    this.loginDetails.roleId = this.$route.query.data.roleId;
                    this.loginDetails.invoiceWoInventory = this.$route.query.data.invoiceWoInventory;
                    this.loginDetails.changePriceDuringSale = this.$route.query.data.changePriceDuringSale;
                    this.loginDetails.isExpenseAccount = this.$route.query.data.isExpenseAccount;
                    this.loginDetails.giveDicountDuringSale = this.$route.query.data.giveDicountDuringSale;
                    this.loginDetails.viewCounterDetails = this.$route.query.data.viewCounterDetails;
                    this.loginDetails.transferCounter = this.$route.query.data.transferCounter;
                    this.loginDetails.closeCounter = this.$route.query.data.closeCounter;
                    this.loginDetails.isSupervisor = this.$route.query.data.isSupervisor;
                    this.loginDetails.holdCounter = this.$route.query.data.holdCounter;
                    this.loginDetails.closeDay = this.$route.query.data.closeDay;
                    this.loginDetails.startDay = this.$route.query.data.startDay;
                    this.loginDetails.processSaleReturn = this.$route.query.data.processSaleReturn;
                    this.loginDetails.dailyExpenseList = this.$route.query.data.dailyExpenseList;
                    this.loginDetails.terminalId = this.$route.query.data.terminalId;
                    this.loginDetails.firstName = this.$route.query.data.firstName;
                    this.loginDetails.lastName = this.$route.query.data.lastName;
                    this.loginDetails.email = this.$route.query.data.email;
                    this.loginDetails.userName = this.$route.query.data.userName;
                    this.loginDetails.userId = this.$route.query.data.userId;
                    this.loginDetails.isActive = !this.$route.query.data.isActive;
                    this.loginDetails.allowAll = this.$route.query.data.allowAll;
                    this.loginDetails.permissionToStartExpenseDay = this.$route.query.data.permissionToStartExpenseDay;
                    this.loginDetails.touchScreen = this.$route.query.data.touchScreen;
                    this.loginDetails.temporaryCashReceiver = this.$route.query.data.temporaryCashReceiver;
                    this.loginDetails.temporaryCashIssuer = this.$route.query.data.temporaryCashIssuer;
                    this.loginDetails.temporaryCashRequester = this.$route.query.data.temporaryCashRequester;
                    this.loginDetails.days = this.$route.query.data.days;
                    this.loginDetails.limit = this.$route.query.data.limit;
                    this.rander++;
                    this.randered++;
                }
            }
        },
        created: function () {
            this.$emit('input', this.$route.name);
        },
        mounted: function () {
            this.invoiveItem = localStorage.getItem('invoiveItem') == "true" ? true : false;
            this.invoiveBarCode = localStorage.getItem('invoiveBarCode') == "true" ? true : false;
            this.invoiveBarCodeItem = localStorage.getItem('invoiveBarCodeItem') == "true" ? true : false;


            if (this.invoiveItem && this.invoiveBarCode && this.invoiveBarCodeItem) {
                this.options = ['Touch Invoice', 'Invoice Barcode', 'Invoice Barcode Item'];
            }
            else if (this.invoiveItem && this.invoiveBarCode) {
                this.options = ['Touch Invoice', 'Invoice Barcode'];
            }
            else if (this.invoiveBarCode && this.invoiveBarCodeItem) {
                this.options = ['Invoice Barcode', 'Invoice Barcode Item'];
            }
            else if (this.invoiveItem && this.invoiveBarCodeItem) {
                this.options = ['Touch Invoice', 'Invoice Barcode Item'];
            }
            else if (this.invoiveItem) {
                this.options = ['Touch Invoice'];
            }
            else if (this.invoiveBarCode) {
                this.options = ['Invoice Barcode'];
            }
            else if (this.invoiveBarCodeItem) {
                this.options = ['Invoice Barcode Item'];
            }
            this.dayStart = localStorage.getItem('DayStart');
            this.english = localStorage.getItem('English');
            this.arabic = localStorage.getItem('Arabic');
            this.isOpenDay = localStorage.getItem('IsOpenDay') == 'true' ? true : false;
            this.language = this.$i18n.locale;
            this.getUserWiseRecords();
            this.invoiceWoInventory = localStorage.getItem('InvoiceWoInventory');
            console.log(this.invoiceWoInventory);

        }
    })
</script>
<style scoped>
</style>